import React from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

/**
 * The single delete glyph used throughout OLC.
 *
 * Keep contextual color and size at the call site; the icon shape must remain
 * the Material outlined delete glyph.
 */
const OlcDeleteIcon = ({ size = 20, sx, ...props }) => (
  <DeleteOutlineOutlinedIcon
    {...props}
    sx={[
      {
        fontSize: size,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default OlcDeleteIcon;
